import React from 'react'
import { useDrag } from 'react-dnd'

import { EDITOR } from '../../config/constants'

const draggingStyles = { zIndex: 1000 }

export const Draggable = ({ children, id, type, position, zIndex = 0, canDrag }) => {
  const { left, top } = position || EDITOR.DEFAULT_POSITION

  const draggableStyles = { position: 'absolute', left, top, zIndex }

  const [{ isDragging }, drag] = useDrag({
    item: { id, left, top, type },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
    }),
    canDrag,
  })

  if (isDragging) {
    return <div ref={drag} style={draggingStyles} />
  }

  return (
    <div ref={drag} style={draggableStyles}>
      {children}
    </div>
  )
}
